import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

/**
 * Keep me around. I'm for feature flags. Plopperoonie.
 */
const useFeatureFlagsStore = defineStore('featureFlags', () => {
  /**
   * Enforce role checks in the UI. On by default; the dev menu can turn it off
   * to preview the ungated experience or to work around a role misassignment.
   */
  const rbacEnforced = useLocalStorage('feature:rbac-enforced', true)

  return { rbacEnforced }
})

export default useFeatureFlagsStore
